import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MobileOffIcon from '@material-ui/icons/MobileOff';
import PropelIcon from '../icons/Propel';
import classnames from 'classnames';

import combineStyles from '../../utils/combineStyles';
import MobileNotAllowedStyles from './__styles__/MobileNotAllowed.styles';
import TypographyStyles from '../../styles/typography';

export const MobileNotAllowed = ({ classes }) => (
  <div className={classes.root}>
    <PropelIcon className={classes.logo} />
    <div className={classnames(classes.alert, classes.headline6)}>
      <MobileOffIcon className={classes.icon} />
      <p className={classnames(classes.headline5, classes.error)}>
        Device not supported.
      </p>
      <p className={classnames(classes.body1Light, classes.message)}>
        Please visit Propel from a tablet or computer.
      </p>
    </div>
  </div>
);

export default withStyles(
  combineStyles(MobileNotAllowedStyles, TypographyStyles)
)(MobileNotAllowed);
